import { LitElement } from 'lit';
import { DedupeMixin, wasApplied } from './dedupe.js';
export class ResizeClass extends LitElement {
}
export const ResizeMixin = (base) => {
    if (wasApplied(ResizeMixin, base)) {
        return base;
    }
    class Resize extends base {
        _initResizeObserver() {
            const observer = Resize._resizeObserver;
            if (observer == null) {
                Resize._resizeObserver = new ResizeObserver((entries) => {
                    Resize._animationFrameID = requestAnimationFrame(() => {
                        if (Array.isArray(entries) && entries.length) {
                            entries.forEach((entry) => {
                                const { target, contentRect } = entry;
                                target.handleResize(contentRect);
                            });
                        }
                    });
                });
            }
        }
        handleResize(contentRect) {
            if (super.handleResize) {
                super.handleResize(contentRect);
            }
            this.dispatchEvent(new CustomEvent('resize', {
                detail: {
                    contentRect,
                },
                bubbles: true,
                composed: true,
            }));
        }
        unobserveAll() {
            if (super.unobserveAll) {
                super.unobserveAll();
            }
            const observer = Resize._resizeObserver;
            if (observer) {
                observer.disconnect();
            }
        }
        connectedCallback() {
            super.connectedCallback();
            this._initResizeObserver();
            const observer = Resize._resizeObserver;
            if (observer && this.isConnected) {
                observer.observe(this);
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            const observer = Resize._resizeObserver;
            const timerId = Resize._animationFrameID;
            if (observer) {
                observer.unobserve(this);
            }
            if (timerId) {
                cancelAnimationFrame(timerId);
            }
        }
    }
    DedupeMixin(ResizeMixin, Resize);
    return Resize;
};
//# sourceMappingURL=resize-observer.js.map